import React, { Component } from 'react';
import cx from 'classnames';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import { isValidEmail } from 'client/utils/validate';
import InputGroup from './inputGroup';

type Props = {
  buttonClassName: string,
  buttonContents: React.Element,
  buttonLabel: TranslateProps,
  buttonStyle: Object,
  className: string,
  error: TranslateProps,
  id: string,
  initialValue: string,
  label: TranslateProps,
  submitHandler: Function,
  hideIconSearch: boolean,
  hasEmailInput: boolean,
};

const defaultProps = {
  buttonClassName: 'icon-search',
  buttonContents: null,
  buttonLabel: null,
  buttonStyle: { width: 50 },
  className: '',
  error: null,
  id: 'zip-input',
  initialValue: '',
  label: { path: 'common.label.zipCode' },
  submitHandler: () => {},
  hideIconSearch: false,
  hasEmailInput: false,
};

export default class InputZip extends Component<Props> {
  constructor(props) {
    super(props);
    this.state = { value: props.initialValue, error: null, email: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    // Check if input is a valid number
    const { value } = event.target;
    const isValid = /^\d{0,5}$/.test(value);

    this.setState(prev => ({
      ...prev,
      value: isValid ? value : prev.value,
      error: isValid && value.length === 5 ? null : prev.error,
    }));
  }

  handleEmailChange(event) {
    const { value: email } = event.target;

    this.setState(prev => ({
      ...prev,
      email,
      emailError: !email || isValidEmail(email) ? null : prev.emailError,
    }));
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email, value } = this.state;
    let isValid = true;
    if (value.length !== 5) {
      this.setState({ error: { path: 'common.error.invalidZip' } });
      isValid = false;
    }

    if (email && !isValidEmail(email)) {
      this.setState({ emailError: { path: 'common.error.invalidEmail' } });
      isValid = false;
    }

    if (isValid) {
      this.props.submitHandler(value, email);
    }
  }

  render() {
    const {
      buttonClassName,
      buttonContents,
      buttonLabel,
      buttonStyle,
      className,
      error,
      id,
      label,
      hideIconSearch,
      ...props
    } = this.props;

    return (
      <form onSubmit={this.handleSubmit} data-testid="form">
        <InputGroup
          {...props}
          containerClassName={className}
          error={error || this.state.error}
          id={id}
          label={label}
          onChange={this.handleChange}
          type="tel"
          value={this.state.value}>
          {!this.props.hasEmailInput && (
            <button
              style={buttonStyle}
              className={cx({ [buttonClassName]: !hideIconSearch })}
              onClick={this.handleSubmit}>
              {buttonLabel ? <Translate {...buttonLabel} /> : null}
              {buttonContents || null}
            </button>
          )}
        </InputGroup>
        {this.props.hasEmailInput && (
          <>
            <InputGroup
              {...props}
              containerClassName={className}
              error={this.state.emailError}
              id="email"
              label={{ path: 'common.label.emailOptional' }}
              onChange={this.handleEmailChange}
              type="tel"
              value={this.state.email} />
            <p style={{ fontSize: '0.875rem', marginBottom: '2rem' }}>
              <Translate path="common.label.informationSafe" />
            </p>
            <div className="text-center" style={{ padding: '1rem 1rem' }}>
              <Button className="cta-button" onClick={this.handleSubmit}>
                <Translate path="common.label.next" />
              </Button>
            </div>
          </>
        )}
      </form>
    );
  }
}

InputZip.defaultProps = defaultProps;
